<svelte:options customElement="hb-checkout-shopping-cart" />

<script lang="ts">
  /**
   * Svelte Invoice WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */
  import type {
    IActionButton,
    IFilter,
    IRow,
    ITableHeader,
  } from "../table/types/webcomponent.type";

  import pkg from "../../../package.json";

  import "dayjs/locale/it";
  import type { IShoppingPayment } from "./types/webcomponent.type";
  import {
    addComponent,
    getChildStyleToPass,
    LanguageTranslator,
  } from "wc-js-utils";
  import parseStyle from "style-to-object";

  import { styleSetup as tableStyleSetup } from "../table/extra/docs";
  import type { Component } from "./types/webcomponent.type";

  let {
    id = undefined,
    // style = undefined,
    completed = "no",
    payment = { countryCode: "IT", currencySymbol: "€", items: [] },
  }: Component = $props();

  let parsedStyle: { [x: string]: string } = $state({});
  let tableStyleToSet: string = $state("");

  const tableHeaders: ITableHeader[] = [
    {
      key: "name",
      label: "nome",
      nosort: true,
    },
    {
      key: "quantity",
      label: "n.",
      nosort: true,
    },
    {
      key: "total",
      label: "totale",
      nosort: true,
    },
  ];

  let tableRows: IRow[] = $state([]);
  let subTotal: number = $state(0);
  let taxTotal: number = $state(0);
  let total: number = $state(0);
  $effect(() => {
    // if (style) {
    //   parsedStyle = parseStyle(style) as any;
    //   tableStyleToSet = getChildStyleToPass(parsedStyle, tableStyleSetup?.vars);
    // }

    if (!payment) {
      payment = { countryCode: "IT", currencySymbol: "€", items: [] };
    } else if (typeof payment === "string") {
      payment = JSON.parse(payment) || {};

      if (!payment.countryCode) payment.countryCode = "IT";
      if (!payment.currencySymbol) {
        switch (payment.countryCode) {
          case "IT":
            payment.currencySymbol = "€";
            break;
          case "EU":
            payment.currencySymbol = "€";
            break;
          case "US":
            payment.currencySymbol = "$";
            break;
        }
      }
    }

    if (payment?.items?.length) {
      tableRows = payment.items.map((m, i) => {
        const r: IRow = {
          _id: i.toString(),
          price:
            m.unitaryPrice.toString() +
            payment.currencySymbol +
            " / " +
            (m.unit ? m.unit : "unità"),
          name: m.name,
          quantity: m.quantity?.toString?.() || "1",
          subtotal:
            (m.unitaryPrice * (m.quantity || 1)).toString() +
            payment.currencySymbol,
          vat: `${(Math.round(m.taxPercentage * 0.01 * m.unitaryPrice * (m.quantity || 1) * 100) / 100).toString()} (${m.taxPercentage}%)`,
          total:
            (
              m.unitaryPrice * (m.quantity || 1) +
              Math.round(
                m.taxPercentage *
                  0.01 *
                  m.unitaryPrice *
                  (m.quantity || 1) *
                  100,
              ) /
                100
            ).toString() + payment.currencySymbol,
        };

        return r;
      });
    }
    subTotal = payment?.items
      ?.map((m) => m.unitaryPrice * (m.quantity || 1))
      .reduce((accumulator, a) => {
        return accumulator + a;
      }, 0);
    taxTotal = payment?.items
      ? Math.round(
          payment?.items
            .map(
              (m) =>
                m.unitaryPrice * (m.quantity || 1) * m.taxPercentage * 0.01,
            )
            .reduce((accumulator, a) => {
              return accumulator + a;
            }, 0) * 100,
        ) / 100
      : 0;

    total = subTotal + taxTotal + (payment.shipmentFee || 0);
  });
  // const component = get_current_component();
  // const svelteDispatch = createEventDispatcher();
  // function dispatch(name:string, detail:any) {
  // 	svelteDispatch(name, detail);
  // 	component.dispatchEvent && component.dispatchEvent(new CustomEvent(name, { detail }));
  // }

  addComponent({
    repoName: "@htmlbricks/hb-table",
    version: pkg.version,
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<div id="page" class="container">
  <h3>
    <i style="font-size:0.9em;margin-right:0.2em" class="bi bi-cart-fill"
    ></i>Shopping Cart
  </h3>
  <div class="row" style="margin:40px auto 20px auto">
    <div class="col">
      <div style="line-height:25px">
        <span style="display:inline-block">SubTotale</span>
        <span style="float:right">{subTotal}{payment.currencySymbol}</span>
      </div>
      <div style="line-height:25px">
        <span style="display:inline-block">Tasse</span>
        <span style="float:right">{taxTotal}{payment.currencySymbol}</span>
      </div>
      <div style="line-height:25px;">
        <span style="display:inline-block">Spedizione</span>
        <span style="float:right"
          >{payment?.shipmentFee
            ? payment?.shipmentFee + (payment?.currencySymbol || "")
            : "-"}</span
        >
      </div>
      <div style="line-height:25px;font-weight:bold">
        <span style="display:inline-block">Totale</span>
        <span style="float:right">{total}{payment.currencySymbol}</span>
      </div>
    </div>
  </div>
  <div class="row cart_divider">
    <div class="col">
      <hb-table
        style={tableStyleToSet}
        disablepagination="yes"
        rows={JSON.stringify(tableRows)}
        headers={JSON.stringify(tableHeaders)}
      ></hb-table>
    </div>
  </div>
</div>

<style lang="scss">
  @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
  #page {
    padding-top: 20px;
  }
  .cart_divider {
    padding-top: 40px;
    border-top: var(--hb-checkout-border);
  }
</style>
